/*global define:false, console:false */

/**
 * cookies.js
 *
 * A cookie reader/writer framework with full unicode support.
 *
 * Modified from: https://developer.mozilla.org/en-US/docs/DOM/document.cookie
 */
define('utils/cookies',[], function() {
    'use strict';

    function _getDomain() {
        var hostName = window.location.hostname;
        return hostName.substr(hostName.indexOf('.'));
    }

    return {
        create: function(name, value, end) {
            if (!name || /^(?:expires|max\-age|path|domain|secure)$/i.test(name)) { return; }
            var expires = '';
            if (end) {
                switch (end.constructor) {
                    case Number:
                        expires = end === Infinity ? '; expires=Tue, 19 Jan 2038 03:14:07 GMT' : '; max-age=' + end;
                        break;
                    case String:
                        expires = '; expires=' + end;
                        break;
                    case Date:
                        expires = '; expires=' + end.toGMTString();
                        break;
                }
            }
            document.cookie = name + '=' + escape(value) + expires + '; domain=' + _getDomain() + '; path=/';
        },

        find: function(name) {
            if (!name || !this.hasItem(name)) { return null; }
            return unescape(document.cookie.replace(new RegExp('(?:^|.*;\\s*)' + name.replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*'), '$1'));
        },

        remove: function(name, path) {
            if (!name || !this.hasItem(name)) { return; }
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        },

        hasItem: function(name) {
            return (new RegExp('(?:^|;\\s*)' + name.replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
        }
    };
});
